import { requestApi } from 'api/Api';

export const importPatients = async (navigate, params) => {
  return requestApi({ navigate, params, url: '/api/admin/practice/import_patients' });
};

export const pastImports = async (navigate, params) => {
  return requestApi({ navigate, params, url: '/api/admin/practice/get_imports' });
};

export const getImportMetadata = (navigate, params) =>
  requestApi({ navigate, params, url: '/api/practice/imports/metadata' });
